import { cn } from "../lib/cn";
import { AvatarIcon, type AvatarIconProps } from "./avatar-icon";
import { Icon } from "./icon";

export interface AvatarPickerProps extends AvatarIconProps {
	/**
	 * Подпись кнопки для скринридера: «Выбрать фото». Обязательна — текстовых
	 * умолчаний в ките нет, кит живёт на 21 локали.
	 */
	label: string;
	/** Открыть выбор файла. Кадрирование и загрузку делает вызывающая сторона. */
	onSelect: () => void;
	/** Идёт загрузка — второй клик дал бы вторую заявку на тот же аватар. */
	disabled?: boolean;
	className?: string;
}

/**
 * Аватар, который меняют кликом по знаку камеры на нём.
 *
 * Вместо пары кнопок «Выбрать фото» / «Удалить фото» рядом с портретом: они
 * занимали строку, требовали двух подписей на 21 языке и предлагали действие,
 * которого в продукте быть не должно. Удаления нет намеренно — аватар не
 * исчезает, а заменяется: `/api/avatar/{userId}` всегда отдаёт картинку, и
 * «удалить» означало бы вернуться к сгенерированной заглушке, то есть к тому же
 * изображению, только чужому по смыслу. Фото уходит вместе с аккаунтом, когда
 * человек удаляет аккаунт.
 *
 * Знак стоит в правом нижнем углу и обведён цветом карточки: на тёмной
 * фотографии серый круг без обводки сливался с ней.
 */
export function AvatarPicker({
	label,
	onSelect,
	disabled = false,
	className,
	...avatar
}: AvatarPickerProps) {
	return (
		<div className={cn("relative w-fit", className)}>
			<AvatarIcon {...avatar} />
			<button
				type="button"
				aria-label={label}
				disabled={disabled}
				onClick={onSelect}
				className={cn(
					"iec-press-sm focus-ring absolute right-0 bottom-0 flex size-8 items-center justify-center",
					"rounded-full border-2 border-card bg-btn-secondary text-fg",
					"transition-colors duration-150 ease-smooth hover:bg-btn-secondary-hover",
					"cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
				)}
			>
				<Icon name="Camera" size={16} />
			</button>
		</div>
	);
}
